module.exports = global["hwcrypto"] = require("-!/data/jenkins/workspace/ep-osgi-parent/ui/ng-core/node_modules/exports-loader/index.js?hwcrypto!./hwcrypto.js");


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/lib/hwcrypto.js
// module id = 130
// module chunks = 0